// siginFile Store Module
export const state = {
  siginFileInfo: {
    fileId: "",
    fileType: "file",
    pages: [
      {
        pageId: "b8b5bde9463449789067c734f35abf2d",
        pageIndex: 0,
        imageUrl:
          "https://ossfastmake.mustke.com/RDGfnrNeQcxIh3Mp/modularImg/1767870086303.jpg",
        regions: [],
      },
      {
        pageId: "b8b5bde9463449789067c734f35abf3d",
        pageIndex: 1,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde9463449789067c734f35abf5d",
        pageIndex: 2,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde9463449789067adc734f35abf5d",
        pageIndex: 3,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde9463s449789067cgfga734f35abf5d",
        pageIndex: 4,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde94631z449789067c734f35abf5d",
        pageIndex: 5,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde94634gs49789067c734f3dsd5abf5d",
        pageIndex: 6,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde9463449789aaa067c734f35abf5d",
        pageIndex: 7,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
      {
        pageId: "b8b5bde946a1233449aaa789067c734f35abf5d",
        pageIndex: 8,
        imageUrl:
          "https://ossfastmake.mustke.com/convert_images/9846a90eb7f24f9092cb79a1cb1fd49e_page1_b8b5bde9463449789067c734f35abf2d.png",
        regions: [],
      },
    ],
  },
  siginFileInfoCommit: false,
};

export const getters = {
  siginFileInfo: (state) => state.siginFileInfo,
  siginFileInfoCommit: (state) => state.siginFileInfoCommit,
};

export const mutations = {
  SET_SIGIN_FILE_INFO(state, payload) {
    state.siginFileInfo = payload;
  },
  SET_SIGIN_FILE_INFO_COMMIT(state, payload) {
    state.siginFileInfoCommit = payload;
  },
};

export const actions = {
  setSiginFileInfo({ commit }, payload) {
    commit("SET_SIGIN_FILE_INFO", payload);
  },
  setSiginFileInfoCommit({ commit }, payload) {
    commit("SET_SIGIN_FILE_INFO_COMMIT", payload);
  },
};
